import * as React from 'react';
import { Field, Form } from 'react-final-form';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useTranslation } from 'react-i18next';

import { BaseButton, Tooltip, ModalX, ModalXProps } from '../../../../../BaseComponents';

import { useConfig } from '../../../../../context';
import { useTheme } from '../../../../../theme';

import { SafeHtml } from '@shared/ui';

interface Props {
	isOpen: boolean;
	onClose?: () => void;
	onSubmit: () => void;
	classes?: ModalXProps['classes'];

	rules: string;
}

let lastVisibleError = '';

const AcceptCheckinRules: React.FC<Props> = ({ isOpen, onClose, classes, onSubmit, rules }) => {
	const { AcceptCheckinRules: css } = useTheme('Features').StartCheckIn;
	const { t } = useTranslation('CheckinRules');

	const {
		global: {
			companyInfo: { iataCode }
		}
	} = useConfig();

	if (iataCode === 'N4') {
		return null;
	}

	return (
		<ModalX isOpen={isOpen} onClose={onClose} classes={classes} size="xlarge">
			<div className={css.rules}>
				<h3 className={css.rules__title}>{t('Terms & Conditions')}</h3>
				<SafeHtml tag="div" className={css.rules__text} html={rules} />
				<Form onSubmit={onSubmit}>
					{({ handleSubmit }) => (
						<form className={css.rules__footer} onSubmit={handleSubmit}>
							<Field
								type="checkbox"
								name="agree"
								initialValue={false}
								validate={value => {
									if (!value) {
										return t('Please read and accept the online check-in terms and conditions');
									}
								}}
							>
								{({ meta, input }) => {
									if (meta.error) {
										lastVisibleError = meta.error;
									}

									return (
										<FormControlLabel
											classes={{
												label: css.rules__label
											}}
											control={
												<Tooltip
													open={meta.submitFailed && !input.value}
													title={lastVisibleError}
													placement="top-start"
												>
													<Checkbox
														color="primary"
														classes={{
															colorPrimary: css.rules__checkbox,
															checked: css.rules__checkbox_checked
														}}
														checked={input.checked}
														inputProps={{ ...input } as any}
													/>
												</Tooltip>
											}
											label={
												<span
													dangerouslySetInnerHTML={{
														__html: t(
															'I have read and agreed to the online check-in terms and conditions'
														)
													}}
												/>
											}
										/>
									);
								}}
							</Field>

							<BaseButton type="submit" variant="action" className={css.rules__button}>
								{t('Continue')}
							</BaseButton>
						</form>
					)}
				</Form>
			</div>
		</ModalX>
	);
};

export default AcceptCheckinRules;
